module.exports = __webpack_public_path__ + "img/block_5_circle.41fe1a29.png";